import React, { useState} from 'react';
import "./Qualification.css";

import { MdOutlineCastForEducation } from "react-icons/md";
import { BiBriefcaseAlt, BiCalendar } from "react-icons/bi";

const Qualification = () => {

    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }

  return (
    <section className="qualification section">
        <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">My personel journey</span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div 
                className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                onClick={() => toggleTab(1)}>
                    <MdOutlineCastForEducation className="qualification__icon" />{" "} Education
                </div>
                <div className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                onClick={() => toggleTab(2)}>
                    <BiBriefcaseAlt className="qualification__icon" />Experience
                </div>
            </div>

            <div className="qualification__sections">
                <div 
                className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}
                >
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Certified Tech Developer</h3>
                            <span className="qualification__subtitle">Digital House</span>
                            <div className="qualification__calender">
                                <BiCalendar className=''/> 2021 - 2023
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                        </div>
                    </div>
                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                            
                        </div>
                        <div>
                            <h3 className="qualification__title">Frontend Developer</h3>
                            <span className="qualification__subtitle">Imagine School</span>
                            <div className="qualification__calender">
                                <BiCalendar className=''/> 2021
                            </div>
                        </div>
                        
                    </div>

                    
                </div>


                <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Web Designer</h3>
                            <span className="qualification__subtitle">Freelancer</span>
                            <div className="qualification__calender">
                                <BiCalendar className=''/> 2021 -2022
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"> </span>
                                <div className="qualification__line"></div>
                           
                        </div>
                    </div>
                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                            
                        </div>
                        <div>
                            <h3 className="qualification__title">Frontend Developer</h3>
                            <span className="qualification__subtitle">Freelancer</span>
                            <div className="qualification__calender">
                                <BiCalendar className=''/> 2020 - Present
                            </div>
                        </div>
                        
                    </div>

                    
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification;